import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { Redirect } from 'react-router-dom';

class CatchErro extends XAPPComponent {

    state = {
        hasError: false,
        error: "",
        info: ""
    };

    componentDidCatch(error, info) {
        this.setState({ "hasError": true, "error": error, "info": info, "path": this.props.url });
    }

    getErro = (_AErro) => {
        var AResponse = "";
        if (_AErro.message !== undefined) {
            AResponse = _AErro.message.toString().split(' ').join('_');
        }
        return AResponse;
    }

    render() {
        var ARota = "/error";
        var AError = this.getErro(this.state.error);

        if (AError.length > 0) {
            ARota = ARota + "?q=" + AError;
        }

        if (this.state.hasError) {
            return (<Redirect to={ARota} />);
        }
        else {
            return this.props.children;
        }
    };
}

export default CatchErro;
